import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import PresenceAvatar from '@ciscospark/react-container-presence-avatar';

import styles from './styles.css';


const propTypes = {
  children: PropTypes.node,
  avatarId: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string
};

const defaultProps = {
  children: undefined,
  avatarId: '',
  name: '',
  type: 'default'
};

function TitleBar({
  avatarId, children, name, type
}) {
  return (
    <div className={classNames('ciscospark-title-bar', styles.titleBar)}>
      <div className={classNames('ciscospark-avatar-container', styles.avatarContainer)}>
        <PresenceAvatar avatarId={avatarId} name={name} spaceType={type} />
      </div>
      <div className={classNames('ciscospark-title-text', styles.titleText)}>
        <h1 className={classNames('ciscospark-title', styles.title)}>{name}</h1>
      </div>
      <div className={classNames('ciscospark-title-meta', styles.titleMeta)}>
        {children}
      </div>
    </div>
  );
}

TitleBar.propTypes = propTypes;
TitleBar.defaultProps = defaultProps;

export default TitleBar;
